import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-arabic-keyboard',
  standalone: false,
  templateUrl: './arabic-keyboard.component.html',
})
export class ArabicKeyboardComponent {
  @Input() formGroup: FormGroup | null = null;
  @Input() activeField: string | null = null;
  @Output() closed = new EventEmitter<void>();

  arabicKeyboardLayout = [
    ['ض', 'ص', 'ث', 'ق', 'ف', 'غ', 'ع', 'خ', 'ح', 'ج', 'د'],
    ['ش', 'س', 'ي', 'ب', 'ل', 'ا', 'ت', 'ن', 'م', 'ك', 'ط'],
    ['ئ', 'ء', 'ؤ', 'ر', 'ى', 'ة', 'و', 'ز', 'ظ', '.', '،'],
  ];

  addCharacter(char: string): void {
    if (!this.activeField || !this.formGroup) return;
    const control = this.formGroup.get(this.activeField);
    if (control) {
      control.setValue((control.value || '') + char);
      control.markAsTouched();
    }
  }

  removeLastCharacter(): void {
    if (!this.activeField || !this.formGroup) return;
    const control = this.formGroup.get(this.activeField);
    if (control) {
      control.setValue((control.value || '').slice(0, -1));
    }
  }

  close(): void {
    this.closed.emit();
  }
}
